import { IHCStain as ImportedIHCStain } from './ihc-stain';

/**
 * @deprecated Use IHCStain class from ihc-stain.ts
 */
const IHCStain = ImportedIHCStain;
export default IHCStain;
